/* eslint-disable */
import { useState,useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import axios from "axios";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Resizer from "react-image-file-resizer";

import { Button, Modal, CardContent } from '@mui/material';
import { LoadingButton } from "@mui/lab";

import { useEnumApi } from 'contexts/EnumApiContext';
import { ROLE } from 'data/data';
import { getEquipmentsById } from "components/axios/equipmentAxios";
import MainCard from 'components/MainCard';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import FileDownloadIcon from "components/FileDownloadIcon";
import { customFileAxios } from "components/axios/customAxios";
import PermissionButton from "components/PermissionButton";
import { PERMISSIONS } from "config/permissions";

const EquipmentImgFileModifyLayer = ({equipmentId, onRefresh}) => {

    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const { role } = useEnumApi();
    const [info, setInfo] = useState(null);
    // const [imgFile, setImgFile] = useState(null);
    // const [imgFileId, setImgFileId] = useState(null);
    const [inputImageItems, setInputImageItems] = useState([]);
    const nextImgID = useRef(1);
    const [fileLoading, setFileLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    const { register, handleSubmit, formState : {isDirty, errors } } = useForm({});
    // modal 관련
    const { openModal } = useModals();
    const handleAlertClick = (alertMessage) => {
        openModal(modals.alertModal, {
            onClose : () => {
            },
            message: alertMessage,
        });
    };

    const handleOpen = () => {
        setOpen(true);
    }
    const handleClose = () => setOpen(false);

    useEffect(() => {
        if (equipmentId && !loading) {
            getEquipmentsById(equipmentId).then((data)=>{
                if (data) {
                    setInfo(data);
                    // setImgFileId((data.imgFile && data.imgFile.id) || null);
                    if (data.imgFiles && data.imgFiles.length > 0) {
                        let inputImageItemsCopy = [];
                        nextImgID.current = 1;
                        for (var j=0;j<data.imgFiles.length;j++) {
                            const input = {	
                                id: nextImgID.current,
                                file: {},
                                imgFile: data.imgFiles[j],
                            };
                            inputImageItemsCopy = [...inputImageItemsCopy, input]
                            nextImgID.current += 1;
                        }
                        setInputImageItems(inputImageItemsCopy);
                    }
                } else {
                    setInfo(null);
                    // setImgFileId(null);
                }
                setLoading(true);
            })
        }
    },[equipmentId, loading]);

    // function fileChangedHandler(event, maxWith, maxHeight, responseUriFunc) {
    //     if (event.target?.files?.[0]) {
    //       try {
    //         Resizer.imageFileResizer(event.target.files[0], maxWith, maxHeight, "JPEG", 90, 0, responseUriFunc, "file", 0, 0)
    //       } catch (err) {
    //         // console.log(err);
    //         handleAlertClick(err.message);
    //         responseUriFunc('')
    //       }
    //     }
    // }

    // 기본이미지삭제
    // function deleteImgFile() {
    //     setImgFileId(null);
    //     setImgFile(null);
    // }

    function addImageFile(file) {
        const input = {	
            id: nextImgID.current,
            file: {},
            imgFile: file,
        };

        setInputImageItems([...inputImageItems, input]);
        nextImgID.current += 1;
    }

    // 삭제
    function deleteImageFile(index) {
        setInputImageItems(inputImageItems.filter(item => item.id !== index));
    }

    async function handleImageFileChange(e, index) {
        if (index > inputImageItems.length) return;

        const compressedFile = (await resizeFile(e.target.files[0], 640, 480));
        
        let inputItemsCopy = [...inputImageItems];
        inputItemsCopy[index].file = compressedFile;
        inputItemsCopy[index].imgFile = null;

        setInputImageItems(inputItemsCopy);
    }

    const resizeFile = (file, maxWidth, maxHeight) =>
        new Promise((res) => {
            Resizer.imageFileResizer(
                file, // target file
                maxWidth, // maxWidth
                maxHeight, // maxHeight
                "JPEG", // compressFormat : Can be either JPEG, PNG or WEBP.
                90, // quality : 0 and 100. Used for the JPEG compression
                0, // rotation
                (uri) => res(uri), // responseUriFunc
                "file" // outputType : Can be either base64, blob or file.(Default type is base64)
                ,0,0	
            );
        }
    );

    const onSubmit = (data, e) => {
        try {
            if (equipmentId) {
                e.preventDefault();
                setFileLoading(true);
                const dto = {
                    id : equipmentId
                }

                let formData = new FormData();
                if(inputImageItems) {
                    let imgFiles = [];
                    for (var r=0;r<inputImageItems.length;r++) {
                        // console.log(inputImageItems[r].file)
                        if (inputImageItems[r].file && inputImageItems[r].file.name) {
                            // console.log(inputImageItems[r].file)
                            formData.append("imgFiles", inputImageItems[r].file);
                        }
                        if (inputImageItems[r].imgFile && inputImageItems[r].imgFile.id) {
                            imgFiles.push({id : inputImageItems[r].imgFile.id});
                        }
                    }
                    dto.imgFiles = imgFiles;
                }
                
                // formData.append("imgFile", imgFile);

                // if (!imgFile && (imgFileId && imgFileId !== 0)) {
                //     dto.imgFile = {id : imgFileId};
                // }
                formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );
                for (var value of formData.entries()) {
                    console.log(value[0]+', ',value[1]);
                }
                openModal(modals.confirmModal, {
                    onSubmit : (value) => {
                        try {
                            const res = customFileAxios.patch(`/api/equipments/${equipmentId}:imgFile`, formData).then((res)=>{
                                setFileLoading(false);
                                onRefresh();
                                setLoading(false);
                                // setImgFile(null)
                                handleAlertClick(t('message.common.alert.modify.done'));
                                handleClose();
                            }).catch((err)=>{
                                console.log(err);
                                setFileLoading(false);
                                handleAlertClick(err.response?.data?.message || err.message);
                            });
                            // return res.data;
                        } catch (error) {
                            console.error("error :", error);
                            throw error;
                        }

                        // axios({
                        //     method: "patch",
                        //     url: window.RUNTIME_CONFIG.REACT_APP_API_URL+"/api/equipments/"+equipmentId+":imgFile",
                        //     data: formData,
                        //     headers : {
                        //         'Content-type' : 'multipart/form-data',
                        //         accept : 'application/json,',
                        //         'Authorization': `Bearer ${localStorage.getItem("persist:root") && JSON.parse(localStorage.getItem("persist:root")).authToken && JSON.parse(JSON.parse(localStorage.getItem("persist:root")).authToken).accessToken}`,
                        //         'Accept-Language' : t('locale')
                        //     }
                        // }).then((res)=>{
                        //     setFileLoading(false);
                        //     onRefresh();
                        //     setLoading(false);
                        //     setImgFile(null)
                        //     handleAlertClick(t('message.common.alert.modify.done'));
                        //     handleClose();
                        // }).catch((err)=>{
                        //     console.log(err);
                        //     setFileLoading(false);
                        //     handleAlertClick(err.response?.data?.message || err.message);
                        // });
                    },
                    onClose : () => {
                        setFileLoading(false);
                        console.log('close');
                    },
                    message: t('message.common.alert.modify.question'),
                });
            }
        } catch(error) {
            console.log(error);
            setFileLoading(false);
        }
    }

    // if (equipmentId && (role === ROLE.SA.code || role === ROLE.WA.code || role === ROLE.MA.code)) {
    if (equipmentId) {
        return (
            <>
                <div>
                    <PermissionButton
                    permission={PERMISSIONS.EQUIPMENT_IMAGE_MODIFY}
                    className="pop_style_btn"
                    type="button"
                    onClick={handleOpen}
                    style={{
                        height: "35px",
                        minHeight: "35px"
                    }}
                    >
                        <span>{t('message.common.btn.modify')}</span>

                        <svg
                            width="15"
                            height="15"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                            style={{
                            display: "block",
                            flexShrink: 0
                            }}
                        >
                            <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                            <path d="M18.375 2.625a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4Z" />
                        </svg>
                    </PermissionButton>
                </div>
                {loading &&
                <Modal
                    className="pop_box equipment_image_renew_pop"
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="equipment-image-modal-title"
                >
                    <MainCard modal darkTitle content={false} sx={{ width: 650, maxWidth: "calc(100vw - 32px)" }}>
                        <div className="equipment_image_modal_header">
                            <div className="equipment_image_modal_heading" id="equipment-image-modal-title">
                                <span aria-hidden="true">🖼️</span>
                                <span>{t('message.common.chip.equipment.basic.picture.modify')}</span>
                            </div>
                        </div>

                        <CardContent className="equipment_image_modal_body">
                            <div className="equipment_image_section_heading">
                                <span>{t('message.common.subtitle.equipment.picture.basic')}</span>
                                {inputImageItems?.length < 4 && (
                                    <button
                                        type="button"
                                        className="equipment_image_add_button"
                                        aria-label="Add image"
                                        onClick={addImageFile}
                                    >
                                        <AddCircleOutlineIcon fontSize="small" />
                                    </button>
                                )}
                            </div>

                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="equipment_image_file_list">
                                    {inputImageItems && inputImageItems.map(function(item, index) {
                                        return (
                                            <div key={item.id} className="equipment_image_file_row">
                                                <span className="equipment_image_row_number">{index + 1}</span>
                                                <div className="equipment_image_file_control">
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        value={''}
                                                        onChange={e => {
                                                            handleImageFileChange(e, index);
                                                        }}
                                                    />
                                                    <div className="equipment_image_file_name">
                                                        {(item.file && item.file.name)
                                                            ? item.file.name
                                                            : (item.imgFile && item.imgFile.id &&
                                                                <FileDownloadIcon file={item.imgFile} viewFileName={true} fontColor="#cbd8e8" />)}
                                                    </div>
                                                </div>
                                                {inputImageItems[index] ? (
                                                    <button
                                                        type="button"
                                                        className="equipment_image_remove_button"
                                                        aria-label="Remove image"
                                                        onClick={() => deleteImageFile(item.id)}
                                                    >
                                                        <RemoveCircleOutlineIcon fontSize="small" />
                                                    </button>
                                                ) : null}
                                            </div>
                                        );
                                    })}
                                </div>
                            </form>

                            <div className="equipment_image_modal_footer">
                                <LoadingButton
                                    variant="contained"
                                    className="equipment_image_save_button"
                                    loading={fileLoading}
                                    onClick={handleSubmit(onSubmit)}
                                >
                                    {t('message.common.btn.modify')}
                                </LoadingButton>
                                <Button
                                    variant="contained"
                                    className="equipment_image_close_button"
                                    size="small"
                                    onClick={handleClose}
                                >
                                    {t('message.common.btn.close')}
                                </Button>
                            </div>
                        </CardContent>
                    </MainCard>
                </Modal>
                }
            </>
        )
    }
}

export default EquipmentImgFileModifyLayer;